export const brandkitDefaultCustomColor = [
  {
    _Value: 4278190080,
    _Name: 'Extended 1',
    _Blend: false,
  },
  {
    _Value: 4294967295,
    _Name: 'Extended 2',
    _Blend: false,
  },
  {
    _Value: 4281545523,
    _Name: 'Extended 3',
    _Blend: false,
  },
  {
    _Value: 4293980400,
    _Name: 'Extended 4',
    _Blend: false,
  },
  {
    _Value: 4293521914,
    _Name: 'Extended 5',
    _Blend: false,
  },
  {
    _Value: 4292144602,
    _Name: 'Extended 6',
    _Blend: false,
  },
  {
    _Value: 4279309369,
    _Name: 'Extended 7',
    _Blend: false,
  },
  {
    _Value: 4294309340,
    _Name: 'Extended 8',
    _Blend: false,
  },
  {
    _Value: 4294948545,
    _Name: 'Extended 9',
    _Blend: false,
  },
]
